import React, { Fragment, useState } from 'react';
import { translate } from '../Services/translation';
import InputField from './InputField';
import { loadError } from '../Actions/RegisterLicenseCode.action';
import { useDispatch } from 'react-redux';
import { catchError } from '../Actions/Error.action';
import { handleApiErrors } from '../Services/Error.service';
import { post } from '../Services/http';
import { removeUrlParameter } from '../Services/UrlUtilities.service';

const RegisterLicenseCodeModal = ({
    acceptTermsCheckboxText,
    acceptTermsText,
    errors,
    handleClose, 
    licenseCode,
    productImageUrl,
    productName,
    redirectUrl
}) => {
    const dispatch = useDispatch();
    const [isActivatingLicense, setIsActivatingLicense] = useState(false);
    const [isAccepting, setIsAccepting] = useState(false);
    const [isSuccessfulDeposit, setIsSuccessfulDeposit] = useState(false);
    const errorMessage = errors?.modal?.[0] ?? undefined;
    
    stopBodyScroll();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsActivatingLicense(true);
        try {
            await post('/api/products/licenseCode', { licenseCode, acceptsTerms: isAccepting });
            setIsSuccessfulDeposit(true);
            if (redirectUrl) window.location.href = redirectUrl;
        } catch (ex) {
            await dispatch(catchError(ex, (error) => handleApiErrors(error, loadError)));
            handleClose();
        }
    }

    const reloadPage = () => {
        const url = removeUrlParameter("licenseCode");
        if (!url) {
            window.location.reload();
        } else {
            window.location.href = url?.href;
        }
    }
    
    const hasProductInformation = productImageUrl !== undefined || productName !== undefined;

    return (
        <div className="register-license-code-modal">

            {isSuccessfulDeposit && !redirectUrl ? (
                <Fragment>
                    <div className="register-license-code-modal__content register-license-code-modal__content--success">
                        <i className="icon-check_circle"></i>
                    <div>{translate('js.registerlicensecode.success.text')}</div>
                    </div>
                    <div className="register-license-code-modal__content register-license-code-modal__content--success-footer">
                        <button className="button button__outline button--full-width" onClick={reloadPage}>
                            <span>{translate('js.registerlicensecode.success.button.text')}</span>
                        </button>
                    </div>
                </Fragment>
            ) : (
                <Fragment>
                    <div className="register-license-code-modal__head">
                    <h5>{translate('js.registerlicensecode.heading.register')}</h5>
                    </div>
                    <div className="register-license-code-modal__content">
                        {errorMessage && !hasProductInformation ? (
                            <Fragment>
                                <h4>{translate('js.registerlicensecode.modal.error.title')}</h4>
                                <div className="register-license-code-modal__error-text">{errorMessage}</div>
                            </Fragment>
                        ) : (
                            <Fragment>
                                <h4>{errorMessage ? translate('js.registerlicensecode.modal.error.title') : translate('js.registerlicensecode.modal.text')}</h4>
                                <div className="register-license-code-modal__card">
                                    {productImageUrl && <img src={productImageUrl} />}
                                    {productName && <div>{productName}</div>}
                                </div>
                                {!errorMessage && (
                                    <div className="register-license-code-modal__content__terms-and-conditions">
                                        <div dangerouslySetInnerHTML={ {__html: acceptTermsText.value} } />
                                        <form>
                                            <InputField
                                                id='acceptTerms'
                                                name='acceptTerms'
                                                type='checkbox'
                                                value='acceptTerms'
                                                checked={isAccepting}
                                                label={acceptTermsCheckboxText}
                                                onChange={(value) => setIsAccepting(value)}
                                                errors={errors}
                                                containerCssClass='label-checkbox'
                                                labelCssClass='label-checkbox__text'
                                                disabled={isActivatingLicense}
                                            />
                                        </form>
                                    </div>
                                )}
                                {errorMessage ? (
                                    <div className="register-license-code-modal__error-text">{errorMessage}</div>
                                ) : (
                                    <button 
                                        className={`button button--full-width ${isActivatingLicense && 'loading'}`} 
                                        disabled={isActivatingLicense || !isAccepting}
                                        onClick={handleSubmit}
                                    >
                                        <span>{translate('js.registerlicensecode.button.confirm.text')}</span>
                                        <span className="spinner spinner--light spinner--small"></span>
                                    </button>
                                )}
                            </Fragment>
                        )}
                        <button className="button button__outline button--full-width" disabled={isActivatingLicense} onClick={handleClose}>
                            <span>{translate('js.registerlicensecode.button.cancel.text')}</span>
                        </button>
                    </div>
                </Fragment>
            )}
        </div>
    )
}

export default RegisterLicenseCodeModal;